import React, { useState } from "react";
import { CheckCircle } from "lucide-react";
import LeadForm from "./LeadForm";
import CustomerDashboard from "./CustomerDashboard";
import CustomerSettings from "./CustomerSettings";
import Card from "../common/Card";
import Button from "../common/Button";

// Full-screen thank-you view shown after a successful quote request submission
function SubmissionSuccess({ onViewDashboard }) {
  return (
    <div className="page customer-shell">
      <Card>
        <div style={{ textAlign: "center", padding: "2rem 1rem" }}>
          <CheckCircle size={48} style={{ marginBottom: "1rem" }} />
          <h2>Your request has been submitted!</h2>
          <p className="muted" style={{ marginBottom: "1.5rem" }}>
            Tradies in your area will review your job and send you quotes shortly.
          </p>
          <Button onClick={onViewDashboard}>View my dashboard</Button>
        </div>
      </Card>
    </div>
  );
}

export default function CustomerApp({ onSubmitRequest, session, role, profile, onViewMessages, messageDeepLink, onDeepLinkConsumed }) {
  // "dashboard" | "form" | "submitted" | "settings"
  const [view, setView] = useState("dashboard");
  const [refreshKey, setRefreshKey] = useState(0);

  // Authenticated customer
  if (session && role === "customer") {
    if (view === "submitted") {
      return (
        <SubmissionSuccess
          onViewDashboard={() => {
            setRefreshKey((k) => k + 1);
            setView("dashboard");
          }}
        />
      );
    }

    if (view === "settings") {
      return (
        <CustomerSettings
          session={session}
          profile={profile}
          onBack={() => setView("dashboard")}
          onProfileUpdated={() => {
            setRefreshKey((k) => k + 1);
            setView("dashboard");
          }}
        />
      );
    }

    if (view === "form") {
      return (
        <LeadForm
          session={session}
          onSubmitRequest={async (request) => {
            await onSubmitRequest(request);
            setView("submitted");
          }}
          onBack={() => setView("dashboard")}
          prefillName={profile?.full_name || ""}
          prefillEmail={session?.user?.email || ""}
        />
      );
    }

    return (
      <CustomerDashboard
        session={session}
        profile={profile}
        onSubmitNew={() => setView("form")}
        refreshKey={refreshKey}
        onViewMessages={onViewMessages}
        onViewSettings={() => setView("settings")}
        messageDeepLink={messageDeepLink}
        onDeepLinkConsumed={onDeepLinkConsumed}
      />
    );
  }

  // Anonymous visitor: straight to form, no prefill
  return <LeadForm onSubmitRequest={onSubmitRequest} />;
}
